//@ts-nocheck
/* eslint no-unused-vars: 0 */

import React from 'react'
import _ from 'lodash'

import changeCase from 'change-case'

import { Text, Divider } from '@wework/dieter-ui'

import { CapacityIcon } from '../../Icons'

function SpaceSummary({ space, noSf, border, containerStyle = {} }: any) {
  const getOfficeNum = () => {
    return space.number || 'N/A'
  }

  function getMetrics(data) {
    let spaceMetric = {
      desks: 0,
      internalRooms: 0,
      sf: 0,
    }

    const { metrics } = space

    if (metrics) {
      spaceMetric = { ...spaceMetric, ...metrics }
    }

    return spaceMetric
  }

  function getPrice(data) {
    const { reservable } = space

    if (!_.get(reservable, 'displayPrice')) {
      return null
    }

    if (reservable) {
      return <span key="price">{`${reservable.displayPrice} •`}</span>
    }

    return null
  }

  function getType() {
    const subType = space.subType?.toUpperCase()
    const programType = space.programType?.toUpperCase()
    let type = ''
    if (subType === 'PRIVATE OFFICE') {
      type = 'Office'
    } else if (programType === 'MEET') {
      type = 'Meeting Room'
    } else {
      type = changeCase.title(subType)
    }
    return type
  }

  function getSeatsCapacity() {
    const { inventoryData, reservable } = space

    let seatsAndCapacity = ''
    let seatCount = 0
    if (reservable) {
      if (space.roomType == 'DEDICATED DESK') {
        seatCount = space.metrics?.desks
      } else {
        if (inventoryData?.relationships?.length > 0) {
          seatCount = inventoryData?.relationships[0]?.seat_count
        }
      }
      seatsAndCapacity = seatCount + ` seats / ${reservable.workUnits} capacity`
    }
    return seatsAndCapacity
  }

  if (!space) {
    return null
  }

  const officeNum = getOfficeNum()
  const price = getPrice()
  const seatAndCapacity = getSeatsCapacity()

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          borderBottom: border ? '1px solid #E6E6E6' : 0,
          alignItems: 'flex-end',
          ...containerStyle,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              paddingRight: '16px',
            }}
          >
            <Text style={{ fontWeight: '700', fontSize: 12, width: 72 }}>
              Space
            </Text>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                border: '0',
                display: 'flex',
                alignItems: 'flex-start',
              }}
            >
              <Text style={{ fontWeight: '400', fontSize: '16px' }}>
                {officeNum}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  fontWeight: '400',
                  color: '#666666',
                  paddingLeft: 5,
                }}
              >
                {getType()}
              </Text>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <div style={{ paddingRight: 5 }}>
                <Text>{seatAndCapacity != '' ? <CapacityIcon /> : ''}</Text>
              </div>
              <div>
                <Text style={{ fontSize: 12, fontWeight: '400' }}>
                  {seatAndCapacity}
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SpaceSummary
